


















import { defineComponent } from '~/utils/nuxt3-migration'
import { ciMarketplace } from '~/icons/source/regular/marketplace'

export default defineComponent({
  props: {
    seller: {
      type: Object,
      required: true
    }
  },
  setup() {
    return {
      ciMarketplace
    }
  },
  computed: {
    otherOutlets() {
      return this.seller.outlets.filter(outlet => outlet.id !== this.seller.id)
    }
  }
})
